import { render, staticRenderFns } from "./TeamPage.vue?vue&type=template&id=4b537b77&"
import script from "./TeamPage.vue?vue&type=script&lang=js&"
export * from "./TeamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b537b77')) {
      api.createRecord('4b537b77', component.options)
    } else {
      api.reload('4b537b77', component.options)
    }
    module.hot.accept("./TeamPage.vue?vue&type=template&id=4b537b77&", function () {
      api.rerender('4b537b77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/TeamPage.vue"
export default component.exports